import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllAdmin,
  selectAllAdmin,
  selectEditError,
  selectLoading,
} from "../redux/admin/adminSlice";
import AdminEditModal from "./AdminEditModal";
// import SignInForm from "./SignInForm";
import SignUpForm from "./SignUpForm";
import { Icon } from "@iconify-icon/react/dist/iconify.js";
import PopConfirm from "./company/PopConfirm";
import { toast } from "react-toastify";
import { deleteAdmin } from "../utils/api/admin";


function AllAdmin() {
  const allAdmin = useSelector(selectAllAdmin);
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const [openModal, setOpenModal] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [confirmPopup, setConfirmPopup] = useState(false);

  const [show, setShow] = useState(false);
  const [user, setUser] = useState(null);
  const [refresh, setRefresh] = useState(false);


  // const error = useSelector(selectEditError);

  useEffect(() => {
    dispatch(getAllAdmin());
  }, [dispatch, refresh]);

  const handleEditClick = (admin) => {
    setSelectedAdmin(admin);
    setOpenModal(true);
  };

  const handleDeleteUser = async (user) => {
    try {
      await deleteAdmin(user.id);
      toast.success("User Deleted");
      setRefresh(!refresh);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="mr-5">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-semibold py-6">All Admins</h1>
        <button
          onClick={() => setShow(true)}
          className="px-5 py-2 bg-black text-white rounded-lg"
        >
          Create Admin
        </button>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : allAdmin ? (
        <table className="border rounded-md  w-full text-center">
          <thead className="border">
            <tr>
              <th className="py-3">Name</th>
              <th className="py-3">Email</th>
              <th className="py-3">Role</th>
              <th className="py-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {allAdmin?.length > 0 &&
              allAdmin.map((admin) => (
                <tr key={admin.id}>
                  <td className="border p-2">{admin.name}</td>
                  <td className="border">{admin.email}</td>
                  <td className="border">{admin.role}</td>
                  {/* <td
                    className="border bg-blue-900 text-white cursor-pointer"
                    onClick={() => handleEditClick(admin)}
                  >
                    <button>Edit</button>
                  </td> */}
                  <td className="px-4 py-2 border border-gray-300">
                    <div className="flex justify-center items-center gap-2">
                      <Icon
                        onClick={() => {
                          handleEditClick(admin);
                        }}
                        className="text-lg text-blue-700 cursor-pointer"
                        icon="fluent:clipboard-text-edit-48-regular"
                      />
                      <Icon
                        onClick={() => {
                          // handleDeleteUser(admin);
                          setUser(admin);
                          setConfirmPopup(true);
                        }}
                        className="text-lg text-gray-700 cursor-pointer"
                        icon="mingcute:delete-2-fill"
                      />
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      ) : (
        <p>No admins found</p>
      )}
      {confirmPopup && (
        <PopConfirm
          closePopup={setConfirmPopup}
          confirm={handleDeleteUser}
          item={user}
        />
      )}
      {show && (
        <div className="bg-transparent w-full flex justify-center items-center z-50">
          <div className="bg-white rounded-md sm:w-[50%] w-full">
            {" "}
            <SignUpForm setShow={setShow} />
          </div>
        </div>
      )}
      {openModal && selectedAdmin && (
        <AdminEditModal admin={selectedAdmin} closeModal={setOpenModal} />
      )}
    </div>
  );
}

export default AllAdmin;
